import React, { FC } from "react";
import { Row, Col } from "reactstrap";
import { PriceCardProps } from "interfaces/cardType";
import "assets/styles/components/card.scss";
import cn from "classnames";
const PriceCard: FC<PriceCardProps> = ({
  coinName,
  tomanPrice,
  rateChange,
  tetherPrice,
  imgSrc,
}) => {
  let isPlus = Math.sign(rateChange) === -1;
  return (
    <Row className="box box-md box-md-width">
      <Col xs="2" className="d-flex align-items-center  justify-content-start">
        <img src={imgSrc} className="coin-logo token-animation" />
      </Col>
      <Col xs="10" className="py-1 py-md-2">
        <Row className=" px-1">
          <Col xs="5">
            <span className="text-light text-nowrap fs-sm">{coinName}</span>
          </Col>
          <Col xs="7" className="text-light text-start fs-sm">
            {tetherPrice}
          </Col>
        </Row>
        <Row className="px-1">
          <Col xs="5">
            <div className="style-ltr d-flex justify-content-end align-items-center fs-8 text-secondary-five-light">
              <i
                className={cn(
                  "px-1",
                  isPlus ? "icon-arrow-down" : "icon-arrow-up"
                )}
              />
              <span className="fs-xs">{rateChange}</span>
            </div>
          </Col>
          <Col xs="7" className="text-start">
            <span className="fs-8 fs-xs text-secondary-five-light">
              {" "}
              {tomanPrice}
            </span>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default PriceCard;
